import { render, staticRenderFns } from "./PostSocialRegistration.vue?vue&type=template&id=d320335c&"
import script from "./PostSocialRegistration.vue?vue&type=script&lang=js&"
export * from "./PostSocialRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PostSocialRegistration.vue?vue&type=style&index=0&id=d320335c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports